export interface ComposerReferenceSnapshot {
  selectedImageIds: string[];
  chatAttachments: Array<{url:string;name:string}>;
  attachedFile: {url:string;name:string} | null;
}
/** Consume only the exact composer values accepted by this request. */
type ScopedReferenceDrafts = { chatAttachmentDrafts?: Record<string, ComposerReferenceSnapshot['chatAttachments']> };
export function consumeComposerReferences(current: ComposerReferenceSnapshot & ScopedReferenceDrafts & {activeProjectId:number|null}, submitted: ComposerReferenceSnapshot, projectId:number|null): Partial<ComposerReferenceSnapshot & ScopedReferenceDrafts> {
  if (current.activeProjectId !== projectId) {
    // A request may be accepted after its task has been left. Consume that
    // task's saved draft, never the visible references in the new destination.
    const key = projectId == null ? null : `task:${projectId}`;
    const draft = key ? current.chatAttachmentDrafts?.[key] : undefined;
    if (!key || !draft || !draft.some(attachment => submitted.chatAttachments.includes(attachment))) return {};
    return { chatAttachmentDrafts: {
      ...current.chatAttachmentDrafts,
      [key]: draft.filter(attachment => !submitted.chatAttachments.includes(attachment)),
    } };
  }
  return {
    selectedImageIds: current.selectedImageIds === submitted.selectedImageIds ? [] : current.selectedImageIds,
    chatAttachments: current.chatAttachments.filter(attachment => !submitted.chatAttachments.includes(attachment)),
    attachedFile: current.attachedFile === submitted.attachedFile ? null : current.attachedFile,
  };
}
